import { LoadingOutlined } from '@ant-design/icons'
import { NorthEast, SouthEast } from '@mui/icons-material'
import styled from 'styled-components'

import { mainText } from 'assets/styles/variables'

// Declared before InfoCard so `&:hover ${KebabSlot}` resolves — styled-
// components needs the referenced component defined first.
export const KebabSlot = styled.div`
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 100;
  opacity: 0;
  transition: opacity 0.15s ease;
`

// Same card frame as Stats.tsx's skeleton `InfoCard`, plus the hover-reveal
// rule for `KebabSlot` — kept local (not shared) so that rule doesn't need a
// cross-file styled-components selector.
export const InfoCard = styled.div`
  position: relative;
  display: flex;
  flex: 1 1 0%;
  min-width: 160px;
  background: #fff;
  border: 1px solid rgb(216, 216, 216);
  border-radius: 8px;
  box-shadow:
    rgba(0, 0, 0, 0.02) 0px 3px 6px -2px,
    rgba(0, 0, 0, 0.04) 0px 1px 1px;
  overflow: hidden;

  &:hover ${KebabSlot}, &:focus-within ${KebabSlot} {
    opacity: 1;
  }
`

export const CardInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  width: 100%;
`

export const TopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`

export const CardLabel = styled.div`
  font-size: 13px;
  letter-spacing: -0.02em;
  font-weight: 500;
  color: rgb(138, 140, 143);
  line-height: 1;
  white-space: nowrap;
`

export const CardValue = styled.div`
  font-size: 24px;
  font-weight: 600;
  color: ${mainText};
  line-height: 1.2;
`

export const LoadingIcon = styled(LoadingOutlined)`
  font-size: 12px;
  color: #aaa;
`

// MUI SvgIcon carries its own internal fontSize class; a plain override here
// loses the specificity/injection-order tie against it without !important —
// same fix as ReportsIcon in trend-detection's AgentCell.tsx.
export const UpIcon = styled(NorthEast)`
  font-size: 12px !important;
`

export const DownIcon = styled(SouthEast)`
  font-size: 12px !important;
`

export const ChangePill = styled.div<{
  $positive: boolean
  $negative: boolean
  $disabled?: boolean
}>`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 4px;
  border-radius: 8px;
  border: 1px solid
    ${({ $positive, $negative, $disabled }) =>
      $disabled
        ? '#d0d5dd'
        : $negative
          ? '#EF4444'
          : $positive
            ? '#10B981'
            : '#d0d5dd'};
  color: ${({ $positive, $negative, $disabled }) =>
    $disabled
      ? 'rgb(138, 140, 143)'
      : $negative
        ? '#EF4444'
        : $positive
          ? '#10B981'
          : mainText};
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
  cursor: default;
`
